import { Component } from '@angular/core';

import { Toast, ToastPackage } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'common-undo-toaster-component',
  styleUrls: ['./undo-toaster.component.scss'],
  templateUrl: `./undo-toaster.component.html`,
  preserveWhitespaces: false,
})
export class UndoToasterComponent extends Toast {
  constructor() {
    super();
  }

  undo() {
    this.toastPackage.triggerAction('undo');
    return true;
  }
}
